/* tslint:disable */
 
import { DataEntityFieldMapping } from './data-entity-field-mapping';
import { FieldBlock } from './field-block';
import { FieldLockedOption } from './field-locked-option';
import { FieldOptions } from './field-options';
import { FieldRenderOptions } from './field-render-options';
import { FieldSourceOptions } from './field-source-options';
import { FieldSources } from './field-sources';
import { FieldValidation } from './field-validation';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { ReferenceProperty } from './reference-property';
import { StepRequirements } from './step-requirements';
import { VirtualField } from './virtual-field';
import { CustomValidations } from './custom-validations';
export class DataEntityField {
  block?: FieldBlock;
  customValidations?: Array<CustomValidations>;
  dataCollection?: null | string;
  dataType: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;
  description?: null | NullableLocalizedValue;
  id?: string;
  isImplicit?: boolean;
  locked?: FieldLockedOption;
  mapping?: null | DataEntityFieldMapping;
  name?: LocalizedValue;
  normalizedName?: string;
  options: FieldOptions;
  renderOptions: FieldRenderOptions;
  requirements?: Array<StepRequirements>;
  source?: null | string;
  sourceOptions?: FieldSourceOptions;
  sources?: Array<FieldSources>;
  specificationVersion: number;
  validations: FieldValidation;
  valueValidators?: Array<ReferenceProperty>;
  virtualField?: null | VirtualField;
}
